import { Slot } from "@radix-ui/react-slot";
import type { ImgHTMLAttributes } from "react";

import { cn } from "../utils/cn";

interface IconPaypalProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

function IconPaypal({ className, asChild = false }: IconPaypalProps) {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn(className)}
      fill="none"
      height="38"
      viewBox="0 0 111 38"
      width="111"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height="38" width="110.359" />
      <mask
        height="26"
        id="mask0_34_115"
        maskUnits="userSpaceOnUse"
        width="95"
        x="8"
        y="6"
      >
        <path d="M102.359 6.5H8V31.5H102.359V6.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_34_115)">
        <path
          d="M42.444 21.6496C45.2729 21.6496 47.675 19.5856 48.1124 16.7879C48.5533 13.9654 46.3523 11.5063 43.2271 11.4993H38.1936C37.9996 11.4993 37.8338 11.6404 37.8056 11.8309L35.5587 26.0773C35.5235 26.2996 35.6928 26.4971 35.9185 26.4971H38.5816C38.7756 26.4971 38.9414 26.356 38.9696 26.1655L39.6292 21.9812C39.661 21.7907 39.8232 21.6496 40.0172 21.6496H42.4405H42.444ZM44.6733 16.6609C44.5075 17.7052 43.7033 18.4743 42.1583 18.4743H40.1866L40.7862 14.6816H42.7227C44.317 14.6816 44.8355 15.6236 44.6733 16.6644"
          fill="#003087"
        />
        <path
          d="M59.6538 15.9906H57.1247C56.9307 15.9906 56.7649 16.1317 56.7367 16.3222L56.6556 16.8479C56.6556 16.8479 54.6909 14.7028 51.2165 16.1493C49.2235 16.9819 48.2676 18.6966 47.8585 19.9491C47.8585 19.9491 46.564 23.77 49.4881 25.8657C49.4881 25.8657 52.1971 27.8837 55.2482 25.7422L55.1953 26.0774C55.16 26.2996 55.3328 26.4972 55.5551 26.4972H58.0841C58.2781 26.4972 58.4439 26.3561 58.4721 26.1656L60.01 16.4104C60.0453 16.1881 59.8725 15.9906 59.6502 15.9906M55.9395 21.3815C55.7173 22.7821 54.5709 23.8123 53.1001 23.8123C52.8108 23.8123 52.5427 23.7735 52.3064 23.6959C51.2165 23.3466 50.5921 22.2988 50.772 21.1627C50.9943 19.7621 52.1442 18.7319 53.615 18.7319C53.9043 18.7319 54.1724 18.7707 54.4087 18.8483C55.4986 19.1976 56.1194 20.2454 55.9395 21.3815Z"
          fill="#003087"
        />
        <path
          d="M78.8562 21.6496C81.6851 21.6496 84.0872 19.5856 84.5246 16.7879C84.969 13.9654 82.7644 11.5063 79.6392 11.4993H74.6058C74.4118 11.4993 74.246 11.6404 74.2178 11.8309L71.9709 26.0773C71.9356 26.2996 72.1085 26.4971 72.3307 26.4971H74.9938C75.1878 26.4971 75.3536 26.356 75.3818 26.1655L76.0414 21.9812C76.0696 21.7907 76.2354 21.6496 76.4294 21.6496H78.8491H78.8562ZM81.0854 16.6609C80.9197 17.7052 80.1154 18.4743 78.5705 18.4743H76.5987L77.1983 14.6816H79.1348C80.7292 14.6816 81.2477 15.6236 81.0854 16.6644"
          fill="#0070E0"
        />
        <path
          d="M96.0695 15.9906H93.5405C93.3465 15.9906 93.1807 16.1317 93.1525 16.3222L93.0713 16.8479C93.0713 16.8479 91.1066 14.7028 87.6322 16.1493C85.6393 16.9819 84.6834 18.6966 84.2743 19.9491C84.2743 19.9491 82.9797 23.77 85.9039 25.8657C85.9039 25.8657 88.6128 27.8837 91.6639 25.7422L91.611 26.0774C91.5758 26.2996 91.7486 26.4972 91.9708 26.4972H94.4999C94.6939 26.4972 94.8597 26.3561 94.8879 26.1656L96.4258 16.4104C96.4611 16.1881 96.2882 15.9906 96.066 15.9906M92.3518 21.3815C92.1295 22.7821 90.9832 23.8123 89.5123 23.8123C89.2231 23.8123 88.955 23.7735 88.7186 23.6959C87.6287 23.3466 87.0044 22.2988 87.1843 21.1627C87.4065 19.7621 88.5564 18.7319 90.0273 18.7319C90.3165 18.7319 90.5846 18.7707 90.8209 18.8483C91.9109 19.1976 92.5317 20.2454 92.3518 21.3815Z"
          fill="#0070E0"
        />
        <path
          d="M68.9375 16.2305L65.8899 21.378L64.3414 16.2693C64.2921 16.1035 64.1369 15.9906 63.964 15.9906H61.2127C61.0117 15.9906 60.8706 16.1846 60.9305 16.3752L63.703 24.9802L61.1951 29.0339C61.0716 29.2315 61.2163 29.4855 61.4455 29.4855H64.4085C64.5813 29.4855 64.74 29.3938 64.8282 29.2491L72.5706 16.4387C72.6906 16.2411 72.5459 15.9906 72.3167 15.9906H69.3537C69.1809 15.9906 69.0186 16.0823 68.9305 16.2305"
          fill="#003087"
        />
        <path
          d="M98.9126 11.8309L96.6657 26.0773C96.6304 26.2996 96.8033 26.5007 97.0255 26.5007H99.6886C99.8826 26.5007 100.048 26.3596 100.077 26.169L102.324 11.9226C102.359 11.7004 102.186 11.5028 101.964 11.5028H99.3006C99.1066 11.5028 98.9408 11.6439 98.9126 11.8344"
          fill="#0070E0"
        />
        <path
          d="M28.0103 18.0086C27.4389 21.2651 24.7793 23.7312 21.2943 23.7312H19.0792C18.6277 23.7312 18.1727 24.1475 18.0986 24.6097L17.1286 30.7662C17.0722 31.1155 16.9099 31.2319 16.5537 31.2319H12.9946C12.6348 31.2319 12.5502 31.1119 12.6066 30.7556L13.0087 26.5007L8.73363 26.2785C8.37384 26.2785 8.23981 26.0774 8.29624 25.7246L11.2133 7.22682C11.2698 6.87754 11.4884 6.72583 11.8412 6.72583H19.2379C22.8005 6.72583 25.0509 9.1214 25.326 12.2296C27.446 13.6656 28.4371 15.5672 28.0103 18.0086Z"
          fill="#001C64"
        />
        <path
          d="M14.0952 19.6068L13.0088 26.4972L12.328 30.8226C12.2716 31.179 12.5467 31.5 12.9065 31.5H16.6666C17.0229 31.5 17.3227 31.2425 17.3791 30.8932L18.3703 24.6097C18.4267 24.2604 18.7266 24.0028 19.0828 24.0028H21.298C24.7865 24.0028 27.7423 21.4591 28.2855 18.0122C28.67 15.5637 27.439 13.3374 25.3332 12.2332C25.3297 12.4907 25.305 12.7483 25.2662 13.0093C24.7265 16.4563 21.7671 19 18.2786 19H14.8148C14.4585 19 14.1587 19.2576 14.1023 19.6068"
          fill="#0070E0"
        />
        <path
          d="M13.0088 26.5007H8.63491C8.27513 26.5007 8 26.1797 8.05644 25.8233L11.0088 7.10683C11.0652 6.75755 11.365 6.5 11.7213 6.5H19.2415C22.8006 6.5 25.3896 9.09314 25.3296 12.2296C24.4443 11.7639 23.4037 11.4993 22.2609 11.4993H15.9929C15.6401 11.4993 15.3368 11.7568 15.2803 12.1061L14.0987 19.6068L13.0123 26.4972L13.0088 26.5007Z"
          fill="#003087"
        />
      </g>
    </Comp>
  );
}

IconPaypal.displayName = "IconPaypal";

export { IconPaypal };
